import type React from "react";

import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const styles = { height: "24px", width: "24px", marginLeft: "auto" };

interface Props {
  checked: boolean;
}

export const AddIcon: React.FC<Props> = ({ checked }) => {
  return checked ? (
    <FontAwesomeIcon icon={faCircleCheck} color="#60c286" style={styles} />
  ) : (
    <FontAwesomeIcon icon={faCirclePlus} color="#273546" style={styles} />
  );
};
